import ShopContent from "../components/ShopContent/ShopContent";
import Hero from "../components/Hero/Hero";

const Shop = () => {
	return (
		<div>
			<Hero title="OUR SHOP" cName="hero__img" />
			<ShopContent />
		</div>
	);
};

export default Shop;
